<template>
  <footer class="page-footer">
    <div class="footer-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-sm-12">
            <div class="footerImg">
              <p style="font-size: 22px;" class="mb-0">
                접속 브랜드 : <span style="color: #c11314;" v-text="brandInfo != null ? brandInfo.brandName : ''"/></p>
              
            </div>

          </div>
          <!--                <div class="col-sm-6 d-none d-sm-block">-->
          <!--                    <ul class="breadcrumb pt-0 pr-0 float-right">-->
          <!--                        <li class="breadcrumb-item mb-0">-->
          <!--                            <a href="#" class="btn-link">Review</a>-->
          <!--                        </li>-->
          <!--                        <li class="breadcrumb-item mb-0">-->
          <!--                            <a href="#" class="btn-link">Purchase</a>-->
          <!--                        </li>-->
          <!--                        <li class="breadcrumb-item mb-0">-->
          <!--                            <a href="#" class="btn-link">Docs</a>-->
          <!--                        </li>-->
          <!--                    </ul>-->
          <!--                </div>-->
        </div>
      </div>
    </div>
    <newFooterVue />
  </footer>
</template>


<script>

import {mapGetters} from "vuex";
import newFooterVue from "./newFooter.vue";

export default {
  computed: {
    ...mapGetters({brandInfo: 'brandInfo'}),
  },
  components:{
    newFooterVue
  }
};
</script>
<style scoped>
.footerImg {display: flex;justify-content: space-between;vertical-align: middle;margin-bottom: 2.0rem;}
.newFooterP {
  position: relative;
}

</style>